<template>
  <!-- WELCOME -->
  <section class="pt-8 pt-md-11">
    <!-- Content -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8 text-center">
          <!-- Heading -->
          <h2>Dedicated node solutions for enterprise</h2>

          <!-- Text -->
          <p class="fs-lg text-muted mb-7 mb-md-9">
            We use our vast experience and extensive infrastructure to provide
            enterprise customers with blockchain node solutions that fit their
            business.
          </p>
        </div>
      </div>
      <!-- / .row -->
    </div>
    <!-- / .container -->
  </section>

  <section class="py-6">
    <!-- Content -->
    <div class="container mb-7 mb-md-9">
      <h2>How it works</h2>

      <div class="list-group">
        <div class="list-group-item d-flex align-items-center">
          <!-- Text -->
          <div class="me-auto">
            <!-- Heading -->
            <p class="fw-bold mb-1">
              We deploy dedicated blockchain nodes on our infrastructure
            </p>

            <!-- Text -->
            <!--<p class="fs-sm text-muted mb-0">
              We don't charge per seat, just per service.
            </p>-->
          </div>

          <!-- Check -->
          <div class="badge badge-rounded-circle bg-success-soft ms-4">
            <i class="fe fe-check"></i>
          </div>
        </div>
        <div class="list-group-item d-flex align-items-center">
          <!-- Text -->
          <div class="me-auto">
            <!-- Heading -->
            <p class="fw-bold mb-1">24/7 monitoring and SLAs</p>

            <!-- Text -->
            <p class="fs-sm text-muted mb-0">
              We deliver on SLAs created to meet your business needs.
            </p>
          </div>

          <!-- Check -->
          <div class="badge badge-rounded-circle bg-success-soft ms-4">
            <i class="fe fe-check"></i>
          </div>
        </div>
        <div class="list-group-item d-flex align-items-center">
          <!-- Text -->
          <div class="me-auto">
            <!-- Heading -->
            <p class="fw-bold mb-1">We manage and operate your nodes</p>

            <!-- Text -->
            <p class="fs-sm text-muted mb-0">
              All day-to-day operations such as updates, monitoring,
              incident-response, etc. is handled by us.
            </p>
          </div>

          <!-- Check -->
          <div class="badge badge-rounded-circle bg-success-soft ms-4">
            <i class="fe fe-check"></i>
          </div>
        </div>
        <div class="list-group-item d-flex align-items-center">
          <!-- Text -->
          <div class="me-auto">
            <!-- Heading -->
            <p class="fw-bold mb-1">Custom-tailored solutions</p>

            <!-- Text -->
            <p class="fs-sm text-muted mb-0">
              We develop custom solutions based on your needs, such as cluster
              size, geographical location, and any other constraints.
            </p>
          </div>

          <!-- Check -->
          <div class="badge badge-rounded-circle bg-success-soft ms-4">
            <i class="fe fe-check"></i>
          </div>
        </div>
      </div>

      <!-- / .row -->
    </div>
    <!-- / .container -->
  </section>

  <section class="py-6 pb-md-13">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8 text-center">
          <!-- Heading -->
          <h2 class="fw-bold">
            Possibly the easiest way for enterprises to get production-grade
            blockchain infrastructure
          </h2>

          <!-- Text -->
          <p class="fs-lg text-muted mb-8 px-lg-9">
            Reach out to our sales team and we'll create a custom-tailored
            solution for your business.
          </p>

          <!-- Button -->
          <button class="btn btn-primary-desat lift" @click="toggleForm">
            Contact sales
          </button>
        </div>
      </div>
      <!-- / .row -->
    </div>
    <!-- / .container -->
  </section>
</template>

<script>
import { createPopup } from "@typeform/embed";

export default {
  name: "Dedicated Nodes for Enterprise",
  methods: {
    toggleForm() {
      const { toggle } = createPopup("IzHtZkK1", {
        onReady: () => {
          this.$gtm.trackEvent({ event: "contactUsClicked" });
        },
        onSubmit: () => {
          this.$gtm.trackEvent({ event: "contactUsSubmitted" });
        },
      });
      toggle();
    },
  },
};
</script>

<style scoped>
@import "~@typeform/embed/build/css/popup.css";
</style>
